import { NOT_AVAILABLE } from "@/data/constants";
import formatCurrency from "./formatCurrency";

export const PRICE_UNAVAILABLE = NOT_AVAILABLE;

type TFormatCurrencyArgs = Parameters<typeof formatCurrency>;

// Money, or "NA" when the plan has no price for the cycle — never a 0 to act on.
export const formatPriceOrNA = (
  amount: number | undefined,
  currency?: TFormatCurrencyArgs[1],
  options?: TFormatCurrencyArgs[2],
) =>
  amount === undefined
    ? PRICE_UNAVAILABLE
    : formatCurrency(amount, currency, options);
